import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserToken } from '../../services/utils';

import HttpClient from '../../services/HttpClient';

const http = new HttpClient();
const baseUrl = 'https://api.kipaa.ir/keepaapp/v1/WalletIssue';
const initialState = {
	mehrWalletStep: 0,
	issueStep: 0,
	isLoading: false,
	walletRequestStatus: [],
	canReqWallet: null,
	walletRequest6monthState: {},
	walletTermsState: null,
	CBIVerification: [],
	walletMessage: '',
	status: null,
	urlPayment: '',
	walletRequestID: null,
	personalInfo: {
		birthDate: '',
		postalcode: '',
		sabteAhval: null,
		fullName: '',
		city: '-',
		province: '-',
		address: '',
	},
	accountInfo: {
		numberAccount: '',
		phoneNumber: '',
		nameEn: '',
		familyEn: '',
	},
	walletCreditInfo: {
		amount: 0,
		operationCost: 0,
		installmentCount: 6,
		installmentPay: 0,
		finalPay: 0,
		karmozd: 0,
	},
	credit: {
		amount: 6000000,
		maxAmount: 20000000,
		minAmount: 2000000,
		amountStep: 500000,
		plan: 'bank_mehr',
	},
	tracking_code: '',
	bank_verify: {},
	mehrValidationState: false,
	isValidCity: null,
	cashPayFee: 0,
	paymentResult: null,
	hasMehrWallet: false,
	sabteAhvalError: false,
	codePostiError: false,
	mehrAccount: false,
	maxAmountError: null,
};

// getWallet
export const walletRequestsStatus = createAsyncThunk('/walletMehr', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {};
	const response = await http
		.post(`${baseUrl}/walletRequestsStatus`, param, extraConfig)
		.then((res) => res.data);
	return response;
});

export const walletRequest6month = createAsyncThunk('/walletRequest', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const parameters = {
		'WalletRequestTypeID': params.WalletRequestTypeID,
	};
	const response = await http
		.post(`${baseUrl}/walletRequest`, parameters, extraConfig)
		.then((res) => res.data);
	return response;
});

export const walletRequestTerms = createAsyncThunk('walletmehr/agreement', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const parameters = {
		'WalletRequestID': params.WalletRequestID,
		'LoanAmount': params.LoanAmount * 10,
	};
	const response = await http
		.post(`${baseUrl}/WalletRequestTerms`, parameters, extraConfig)
		.then((res) => res.data);
	return response;
});

export const CBIVerification = createAsyncThunk('wallet/confirm', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const parametrs = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${baseUrl}/CBIVerification`, parametrs, extraConfig)
		.then((res) => res.data);
	return response;
});

export const PersonalData = createAsyncThunk('walletmehr/personalInfo', async (params, thunkAPI) => {
	const { day, month, year, codePosti, walletRequestID, city, state } = params;
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const parameters = {
		'WalletRequestID': walletRequestID,
		'BirthYear': Number(year),
		'BirthMonth': Number(month),
		'BirthDay': Number(day),
		'Postalcode': codePosti,
		'ProvinceID': Number(state),
		'CityID': Number(city),
	};
	const response = await http
		.post(`${baseUrl}/PersonalData`, parameters, extraConfig)
		.then((res) => res.data);
	return response;
});

export const FinancierRequiredInformation = createAsyncThunk('walletmehr/account', async (params) => {
	const headers = {
		'Authorization': `Bearer ${params.token}`,
	};
	const param = {
		WalletRequestID: params.walletRequestID,
		HasBankAccount: params.hasBankAcc,
		EnName: params.englishName,
		EnLastName: params.englishFamily,
		AccountNumber: params.accountNumber,
		Mobile: params.phone,
	};
	const response = await http
		.post(`${baseUrl}/FinancierRequiredInformation`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});
export const WalletPrePayment = createAsyncThunk('credit/WalletPrePayment', async (params) => {
	const headers = {
		'Authorization': `Bearer ${params.token}`,
	};
	const param = {
		WalletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${baseUrl}/WalletPrePayment`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});
export const GetPrepaymentURL = createAsyncThunk('/payoperation', async (params) => {
	const headers = {
		'Authorization': `Bearer ${params.token}`,
	};
	const param = {
		'WalletRequestID': params.walletRequestID,
		'ReturnURL': 'https://pwa.keepa.ir/paymentResult',
	};
	const response = await http
		.post(`${baseUrl}/GetPrepaymentURL`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});
export const WalletIssueStatus = createAsyncThunk('/issueStatus', async (params) => {
	const headers = {
		'Authorization': `Bearer ${params.token}`,
	};
	const param = {
		'WalletRequestID': params.walletRequestID,
	};
	const response = await http
		.post(`${baseUrl}/WalletIssueStatus`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});
export const PrepaymentStatus = createAsyncThunk('/PrepaymentStatus', async (params) => {
	const headers = {
		'Authorization': `Bearer ${params.token}`,
	};
	const param = {
		'WalletRequestID': params.walletRequestID,
	};
	const response = await http
		.post(`${baseUrl}/PrepaymentStatus`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

const wallet6MonthsSlice = createSlice({
	name: 'walletmehr',
	initialState,
	reducers: {
		setWalletReguestId(state, action) {
			state.walletRequestID = action.payload;
		},
		signOutWallet(initialState) {
			return initialState;
		},
		setAmountCreditMehr(state, action) {
			state.credit.amount = action.payload;
		},
		setValidationStateMehr(state, action) {
			state.mehrValidationState = action.payload;
		},
		setisValidCity(state, action) {
			state.isValidCity = action.payload;
		},
		changeStepMehr(state, action) {
			state.mehrWalletStep = action.payload;
		},
		setSabteAhvalMehrError(state, action) {
			state.sabteAhvalError = action.payload;
		},
		setWalletCreditInfo(state, action) {
			state.walletCreditInfo = action.payload;
		},
		setAccountNum(state, action) {
			state.accountInfo.numberAccount = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder

			.addCase(walletRequest6month.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(walletRequest6month.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Content, Status } = action.payload;
				if (Success) {
					state.walletRequest6monthState = Content.WalletRequestLimits;
					state.walletRequestID = Content.WalletRequestID;
					if (Content.WalletRequestLimits.MaxLoanAmount < Content.WalletRequestLimits.MinLoanAmount)
						state.maxAmountError = true;
				} else if (Status === 643) {
					state.canReqWallet = false;
				}
			})
			.addCase(walletRequest6month.rejected, (state) => {
				state.isLoading = false;
				//  state.walletMessage = "خطا در بر قراری سرور";
			});
		builder
			.addCase(walletRequestsStatus.pending, () => {
				//  state.isLoading = true;
			})
			.addCase(walletRequestsStatus.fulfilled, (state, action) => {
				//     state.isLoading = false;
				const { Success, Content } = action.payload;
				if (Success && Content.WalletRequests.length !== 0) {
					// state.walletRequestStatus = Content.WalletRequests
					const mehrWalletStatus = Content.WalletRequests.filter(
						(d) => d.WalletRequestTypeID === 111111155,
					).slice(-1)[0];
					if (mehrWalletStatus.WalletRequestComplete === 0) {
						state.mehrWalletStep = 0;
						if (
							mehrWalletStatus.WalletRequestLimits.MaxLoanAmount === 0 ||
							mehrWalletStatus.WalletRequestLimits.MaxLoanAmount <
								mehrWalletStatus.WalletRequestLimits.MinLoanAmount
						)
							state.maxAmountError = true;
					}
					if (mehrWalletStatus.WalletRequestComplete === 1) {
						state.hasMehrWallet = true;
						state.walletCreditInfo.amount = mehrWalletStatus.WalletRequestDetails.loanAmount;
					}
					state.walletRequest6monthState = mehrWalletStatus.WalletRequestLimits;

					state.walletRequestID = mehrWalletStatus.WalletRequestID;
				} else {
					//    state.walletMessage = Message;
				}
			})
			.addCase(walletRequestsStatus.rejected, (state) => {
				state.isLoading = false;
				//  state.walletMessage = "خطا در بر قراری سرور";
			});
		builder
			.addCase(walletRequestTerms.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(walletRequestTerms.fulfilled, (state, action) => {
				const { Success } = action.payload;
				if (Success) {
					state.walletTermsState = Success;
					state.isLoading = false;
				} else {
					//  state.walletMessage = Message;
					state.isLoading = false;
				}
			})
			.addCase(walletRequestTerms.rejected, (state) => {
				state.isLoading = false;
				//  state.walletMessage = "خطا در بر قراری سرور";
			});

		builder
			.addCase(CBIVerification.pending, () => {
				// state.status = "pending";
			})
			.addCase(CBIVerification.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) state.bank_verify = Content;
				else {
					state.status = false;
				}
				state.isLoading = false;
			})
			.addCase(CBIVerification.rejected, (state) => {
				state.status = false;
			});
		builder
			.addCase(PersonalData.pending, () => {})
			.addCase(PersonalData.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				const { month, day, year } = action.meta.arg;
				state.codePostiError = false;
				if (Success) {
					if (Content.Identity.IdentityStatus) {
						state.walletMessage = '';
						state.personalInfo.fullName = `${Content.Identity.Name} ${Content.Identity.LastName}`;
						state.personalInfo.birthDate = `${year}/${month}/${day}`;
						state.mehrWalletStep = 2;
						state.mehrAccount = true;
						state.isLoading = false;
					} else {
						if (!Content.Identity.IdentityStatus) state.sabteAhvalError = true;
					}
				}
			})
			.addCase(PersonalData.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(FinancierRequiredInformation.pending, (state) => {
				//  state.isLoading=true;
				state.walletMessage = '';
			})
			.addCase(FinancierRequiredInformation.fulfilled, (state, action) => {
				//   state.isLoading=false
				const { Success } = action.payload;
				const { hasBankAcc } = action.meta.arg;
				if (Success && hasBankAcc) state.mehrWalletStep = 3;
			})
			.addCase(FinancierRequiredInformation.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(WalletPrePayment.pending, () => {
				//   state.walletMessage = "";
			})
			.addCase(WalletPrePayment.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.cashPayFee = Content.IssuanceFee;
					state.mehrWalletStep = 5;
				}
			})
			.addCase(WalletPrePayment.rejected, (state) => {
				state.mehrWalletStep = 3;
			});
		builder
			.addCase(GetPrepaymentURL.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(GetPrepaymentURL.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Content } = action.payload;
				if (Success) {
					state.urlPayment = Content.PaymentURL;
				} else {
					//  state.walletMessage = Message;
				}
			})
			.addCase(GetPrepaymentURL.rejected, (state) => {
				state.isLoading = false;
				//     state.walletMessage = "خطا در بر قراری سرور";
			});
		builder
			.addCase(WalletIssueStatus.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(WalletIssueStatus.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Content } = action.payload;
				if (Success) {
					state.issueStep = Content.WalletIssueStep;
				} else {
					//       state.walletMessage = Message;
				}
			})
			.addCase(WalletIssueStatus.rejected, (state) => {
				state.isLoading = false;
				//  state.walletMessage = "خطا در بر قراری سرور";
			});
		builder
			.addCase(PrepaymentStatus.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(PrepaymentStatus.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Content } = action.payload;
				if (Success) {
					state.paymentResult = Content.result;
				} else {
					state.paymentResult = false;
				}
			})
			.addCase(PrepaymentStatus.rejected, (state) => {
				state.isLoading = false;
				//  state.walletMessage = "خطا در بر قراری سرور";
			});
	},
});

export const {
	setWalletReguestId,
	setAmountCreditMehr,
	setisValidCity,
	setValidationStateMehr,
	changeStepMehr,
	setWalletCreditInfo,
	setAccountNum,
	signOutWallet,
	setSabteAhvalMehrError,
} = wallet6MonthsSlice.actions;
export default wallet6MonthsSlice.reducer;
